module.exports = __webpack_public_path__ + "img/story011@2x.8315eaf7.png";